// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    projectId: 'autlan-51170',
    appId: '1:634955475499:web:5d87752071733e3c14586e',
    storageBucket: "autlan-51170.appspot.com",
    apiKey: "AIzaSyAWEGWaFNXSbm-8qSyMtShUIy-CkJ6-pWM",
    authDomain: "autlan-51170.firebaseapp.com",
    messagingSenderId: "634955475499",
    measurementId: 'G-1W0NN5ZFKH',
  },
  production: false,
  apiUrl: 'https://api.guarderia.saion.mx',

};
